import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIntercom20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconIntercom20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m16.5 18.494-4.1-1.383H4.5a2.5 2.5 0 0 1-2.5-2.5V4.5A2.5 2.5 0 0 1 4.5 2h11A2.5 2.5 0 0 1 18 4.5V19zm0-13.994v12.411l-3.62-1.221-.234-.079H4.5a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1M6.314 11.753l.01.005.047.028q.066.038.202.11c.18.093.447.22.78.347.668.256 1.582.505 2.592.505s1.923-.25 2.592-.505a8 8 0 0 0 .981-.457l.048-.028.009-.005a.75.75 0 0 1 .795 1.271l-.398-.635.398.636h-.001l-.003.002-.007.004-.021.013-.073.043q-.094.054-.26.142c-.223.114-.54.265-.932.415-.78.298-1.881.604-3.128.604s-2.348-.306-3.129-.604a9 9 0 0 1-1.192-.557l-.073-.043-.021-.013-.007-.004-.003-.001v-.001l.397-.636-.398.636a.75.75 0 0 1 .795-1.272"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIntercom20);
